import axiosPost from "./axiosPost";

export const RNESMovimientoGet = async (credentials, data) => {
    const body = {
        service: "RNESMovimientoGet",
        params: {
            rnesAsignacionMSUId: data?.rnesAsignacionMSUId,
        },
    };

    const result = await axiosPost(body, credentials);
    if(result?.status?.code === 0) {
        return [result.status]
    } else {
        return result.result;
    }
};
